// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  padding-top: 30px;
  color: var(--brand-white2);
  font-family: var(--font-family1);
  background: linear-gradient(var(--brand-white6), var(--brand-dark5));
}

footer h2 {
  font-family: var(--font-family1);
  color: var(--brand-white2);
  text-align: center;
  text-shadow: var(--text-shadow2);
}

footer h2 .spread {
  font-family: var(--font-dots1);
  color: var(--brand-red1);
}

.footer-icons-ct {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px 20px;
  padding: 0 5px;
}

.footer-icons-ct svg {
  height: 100px;
  background-color: transparent;
  border-bottom: 2px transparent solid;
  stroke: white;
  stroke-width: 2;
}

.footer-icons-ct svg:hover {
  stroke: var(--brand-red1);
  stroke-width: 6;
  stroke-dasharray: 2 10;
  stroke-linecap: round;
  border-bottom: 2px var(--brand-red1) dotted;
}


footer .contact-info-ct {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

footer .contact-info-ct {
  padding: 20px 0;
}
footer .contact-info-ct .contact-label {
  color: var(--brand-white3);
  margin: 0;
}

footer .contact-info-ct a {
  text-decoration: none;
  color: var(--brand-white3);
}

footer .contact-info-ct a:hover {
  color: var(--brand-green1);
}

footer .contact-info-ct .contact-value {
  margin: 0;
}

.footer-copyright {
  font-size: 80%;
  color: var(--brand-white3);
  text-align: center;
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/footers/Footer1.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,oEAAoE;AACtE;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;AAC7C;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":["footer {\n  padding-top: 30px;\n  color: var(--brand-white2);\n  font-family: var(--font-family1);\n  background: linear-gradient(var(--brand-white6), var(--brand-dark5));\n}\n\nfooter h2 {\n  font-family: var(--font-family1);\n  color: var(--brand-white2);\n  text-align: center;\n  text-shadow: var(--text-shadow2);\n}\n\nfooter h2 .spread {\n  font-family: var(--font-dots1);\n  color: var(--brand-red1);\n}\n\n.footer-icons-ct {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 5px 20px;\n  padding: 0 5px;\n}\n\n.footer-icons-ct svg {\n  height: 100px;\n  background-color: transparent;\n  border-bottom: 2px transparent solid;\n  stroke: white;\n  stroke-width: 2;\n}\n\n.footer-icons-ct svg:hover {\n  stroke: var(--brand-red1);\n  stroke-width: 6;\n  stroke-dasharray: 2 10;\n  stroke-linecap: round;\n  border-bottom: 2px var(--brand-red1) dotted;\n}\n\n\nfooter .contact-info-ct {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n}\n\nfooter .contact-info-ct {\n  padding: 20px 0;\n}\nfooter .contact-info-ct .contact-label {\n  color: var(--brand-white3);\n  margin: 0;\n}\n\nfooter .contact-info-ct a {\n  text-decoration: none;\n  color: var(--brand-white3);\n}\n\nfooter .contact-info-ct a:hover {\n  color: var(--brand-green1);\n}\n\nfooter .contact-info-ct .contact-value {\n  margin: 0;\n}\n\n.footer-copyright {\n  font-size: 80%;\n  color: var(--brand-white3);\n  text-align: center;\n  padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
